import { useCurrencyQueryActions } from '@/api/hooks/currencyQueryActions';

interface CurrencyCodeProps {
  currencyId: string;
}

export const CurrencyCode: FC<CurrencyCodeProps> = ({ currencyId }) => {
  const { useGetCurrencies } = useCurrencyQueryActions();
  const { data } = useGetCurrencies();
  return data?.find((x) => x.id === currencyId)?.code;
};
